/* =====================================================================================================
   mt-farb-baukasten.js - Logik für sections/mt-farb-baukasten.liquid (Farb-Sets nach Wahl), 02.10.2026.
   Genau N Stück (Mehrfachwahl derselben Farbe erlaubt), Stufenpreis aus dem Metaobjekt, Zeilen mit _mt_bundle/_mt_group
   für den Cart-Transform der Bundle-App. Slots mit Nummer in der Zusammenfassung (wie der alte Konfigurator), ein Klick auf
   einen Slot nimmt diese Farbe einmal heraus. Leiste, Blatt, PC-Spalte und Warenkorb über assets/mt-baukasten-hilfe.js.
   ===================================================================================================== */
(function () {
  'use strict';
  function start(root) {
    var H = window.MTBK; if (!H) return;
    var D;
    try { D = JSON.parse(root.querySelector('[data-mbk-daten]').textContent); } catch (e) { return; }
    var T = D.t || {}, E = D.einheit || ['', ''];
    var geld = H.geldFormat(D.geld);
    function tx(k, w) { return H.tx(T, k, w); }
    function e(n) { return n === 1 ? E[0] : E[1]; }
    function gross(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

    var raster = root.querySelector('[data-mbk-raster]');
    var karten = [].slice.call(root.querySelectorAll('[data-mbk-karte]'));
    /* Sortierung aus der Section-Einstellung (16.10.2026): farbfamilie (Standard) = Bestand zuerst (auf Lager > Vorbestellung > Rest >
       nicht bestellbar), danach Farbfamilie wie im alten Konfigurator; artikelnummer = nur nach SKU (natürlich, AK11001 vor AK11383);
       kollektion = Reihenfolge der Kollektion unverändert */
    var SORT = D.sort || 'farbfamilie';
    if (SORT !== 'kollektion') {
      var FAM = D.fam || {};
      var nrVgl = (window.Intl && Intl.Collator) ? new Intl.Collator('de', { numeric: true, sensitivity: 'base' }).compare : function (a, b) { return a < b ? -1 : a > b ? 1 : 0; };
      karten.map(function (k, i) { return { k: k, r: +k.getAttribute('data-rang') || 3, f: FAM[k.getAttribute('data-fam')] || 99, n: k.getAttribute('data-nr') || '', i: i }; })
        .sort(SORT === 'artikelnummer'
          ? function (a, b) { return (!a.n - !b.n) || nrVgl(a.n, b.n) || a.i - b.i; }
          : function (a, b) { return a.r - b.r || a.f - b.f || a.i - b.i; })
        .forEach(function (o) { raster.appendChild(o.k); });
    }
    karten = [].slice.call(root.querySelectorAll('[data-mbk-karte]'));
    var KARTE = {};
    karten.forEach(function (k) { KARTE[k.getAttribute('data-vid')] = k; var st = k.querySelector('[data-st]'); if (st) k._st = st.textContent; });

    var zusAlle = [].slice.call(root.querySelectorAll('.mbk-zus'));
    var addAlle = [].slice.call(root.querySelectorAll('[data-add]'));
    var leisteEl = root.querySelector('[data-mbk-leiste]');
    var lText = leisteEl.querySelector('[data-l-text]');
    var live = root.querySelector('[data-mbk-live]');
    var blatt = root.querySelector('[data-blatt]');

    var stufen = [].slice.call(root.querySelectorAll('[data-stufe]'));
    var sp0 = stufen.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || stufen[0];
    var stufe = { n: +sp0.getAttribute('data-stufe'), p: +sp0.getAttribute('data-p') };
    var q = {}, reihe = [], hinweis = '', laeuft = false;
    var SPEICHER = 'mbk:' + location.pathname;
    try {
      var alt = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null');
      if (alt && alt.q) {
        (alt.r || Object.keys(alt.q)).forEach(function (v) { var k = KARTE[v]; if (k && k.querySelector('[data-start]') && alt.q[v] > 0) { q[v] = Math.min(+alt.q[v], 10); reihe.push(v); } });
        if (alt.n) stufen.forEach(function (b) { if (+b.getAttribute('data-stufe') === +alt.n) stufe = { n: +alt.n, p: +b.getAttribute('data-p') }; });
      }
    } catch (err) {}
    function speichern() { try { sessionStorage.setItem(SPEICHER, JSON.stringify({ q: q, r: reihe, n: stufe.n })); } catch (err) {} }

    /* Einzelpreis (alle Farben einer Reihe kosten gleich) für die Unterzeile der Set-Wahl: „2,70 €/Farbe · statt 14,75 €“ */
    var einzel = karten.length ? (+karten[0].getAttribute('data-preis') || 0) : 0;
    /* Der erste sichtbare Knopf einer Section verliert im Xtra-Theme seine Kind-Elemente - Beschriftungen deshalb hier setzen */
    function beschriften() {
      stufen.forEach(function (b) {
        var n = +b.getAttribute('data-stufe'), p = +b.getAttribute('data-p');
        b.innerHTML = '<b>' + tx('stufe', { n: n }) + '</b><span class="mbk-stufe-p">' + geld(p) + '</span><span class="mbk-stufe-s">' + (einzel ? tx('stufe_s', { p: geld(Math.round(p / n)), e: gross(E[0]), b: geld(einzel * n) }) : '') + '</span>';
        b.setAttribute('aria-pressed', String(stufe.n === n));
      });
      var sch = root.querySelector('[data-f-lager]');
      if (sch && !sch.querySelector('.mbk-spur')) sch.innerHTML = '<span class="mbk-spur" aria-hidden="true"></span><span data-f-lager-t></span>';
      filtern();
    }

    function summe() {
      var n = 0, s = 0;
      reihe.forEach(function (v) { var m = q[v] || 0, k = KARTE[v]; if (!m || !k) return; n += m; s += m * (+k.getAttribute('data-preis') || 0); });
      return { n: n, s: s };
    }
    function rechne() {
      var r = summe(), N = stufe.n, P = stufe.p;
      r.preis = P; r.alt = ''; r.satz = '';
      r.kopf = tx('k_set', { n: r.n, m: N });
      r.ok = r.n === N;
      if (r.ok && r.s > P) { r.alt = tx('statt', { b: geld(r.s) }); r.satz = tx('sparen', { b: geld(r.s - P) }) + ' '; }
      r.satz += T.set_kein_mr || '';
      r.knopf = r.n < N ? tx('noch', { k: N - r.n, e: e(N - r.n) }) : tx('add_set', { m: N });
      r.zuviel = r.n > N ? tx('zu_viel', { k: r.n - N, e: e(r.n - N) }) : '';
      return r;
    }

    /* Slots wie im alten Konfigurator: ein Kreis je Platz, gewählte in ihrer Farbe mit Artikelnummer darunter */
    function slotsBauen(box, n) {
      var plaetze = [];
      reihe.forEach(function (v) { for (var i = 0; i < (q[v] || 0); i++) plaetze.push(v); });
      box.textContent = '';
      for (var i = 0; i < Math.max(stufe.n, n); i++) {
        var v = plaetze[i], el;
        if (v) {
          var k = KARTE[v];
          el = document.createElement('button'); el.type = 'button'; el.className = 'mbk-slot is-on'; el.setAttribute('data-weg', v);
          el.setAttribute('aria-label', tx('weg_a', { name: (k.getAttribute('data-name') || '') + ' (' + (k.getAttribute('data-nr') || '') + ')' }));
          var kr = document.createElement('span'); kr.className = 'mbk-slot-k'; kr.style.background = k.getAttribute('data-sw') || '#ccc';
          var nr = document.createElement('span'); nr.className = 'mbk-slot-nr'; nr.textContent = k.getAttribute('data-nr') || '';
          el.appendChild(kr); el.appendChild(nr);
        } else {
          el = document.createElement('span'); el.className = 'mbk-slot';
          var kl = document.createElement('span'); kl.className = 'mbk-slot-k'; el.appendChild(kl);
        }
        box.appendChild(el);
      }
    }

    function render() {
      var r = rechne();
      karten.forEach(function (k) {
        var v = k.getAttribute('data-vid'), m = q[v] || 0, st = k.querySelector('[data-start]');
        if (!st) return;
        st.hidden = m > 0; k.querySelector('[data-schritt]').hidden = m === 0;
        k.querySelector('[data-n]').textContent = m;
        k.classList.toggle('is-on', m > 0);
        var inv = +k.getAttribute('data-inv'), stEl = k.querySelector('[data-st]');
        if (stEl && k.getAttribute('data-lager') === '1') stEl.textContent = (inv < 999 && m > inv) ? T.st_teil : k._st;
      });
      var hinw = r.zuviel || hinweis;
      zusAlle.forEach(function (z) {
        z.querySelector('[data-z-kopf]').textContent = r.kopf;
        slotsBauen(z.querySelector('[data-z-slots]'), r.n);
        z.querySelector('[data-z-preis]').textContent = geld(r.preis);
        z.querySelector('[data-z-alt]').textContent = r.alt;
        z.querySelector('[data-z-satz]').textContent = r.satz;
        var h = z.querySelector('[data-z-hinw]'); h.textContent = hinw; h.hidden = !hinw;
      });
      addAlle.forEach(function (b) {
        if (laeuft) return;
        b.disabled = !r.ok;
        b.textContent = b.closest('[data-mbk-leiste]') ? (T.add || '') : r.knopf;
      });
      lText.textContent = tx('k_leiste', { n: r.n, m: stufe.n }) + ' · ' + geld(r.preis);
      speichern();
      if (L) L.lauf();
      if (S) S.lauf();
      return r;
    }

    function setze(v, m, fokus) {
      var k = KARTE[v]; if (!k) return;
      m = Math.max(0, Math.min(10, m));
      hinweis = '';
      var vorher = q[v] || 0;
      if (m > vorher && summe().n + (m - vorher) > stufe.n) {
        var groesser = stufen.map(function (b) { return +b.getAttribute('data-stufe'); }).filter(function (n) { return n > stufe.n; })[0];
        hinweis = groesser ? tx('voll_mehr', { m: stufe.n, g: groesser }) : tx('voll', { m: stufe.n });
        render(); H.ansage(live, hinweis); return;
      }
      q[v] = m;
      if (m > 0 && reihe.indexOf(v) < 0) reihe.push(v);
      if (m === 0) { delete q[v]; reihe = reihe.filter(function (x) { return x !== v; }); }
      var r = render();
      H.ansage(live, r.kopf);
      if (fokus) { var z2 = m > 0 ? k.querySelector('[data-plus]') : k.querySelector('[data-start]'); try { z2.focus({ preventScroll: true }); } catch (err) {} }
    }
    raster.addEventListener('click', function (ev) {
      var b = ev.target.closest('button'); if (!b) return;
      var k = b.closest('[data-mbk-karte]'); if (!k) return;
      var v = k.getAttribute('data-vid'), m = q[v] || 0;
      if (b.hasAttribute('data-start')) setze(v, 1, true);
      else if (b.hasAttribute('data-plus')) setze(v, m + 1, false);
      else if (b.hasAttribute('data-minus')) setze(v, m - 1, m <= 1);
    });
    /* Slot antippen = diese Farbe einmal heraus */
    function slotKlick(ev) {
      var b = ev.target.closest('[data-weg]'); if (!b) return;
      var box = b.closest('[data-z-slots]'), idx = [].indexOf.call(box.children, b);
      setze(b.getAttribute('data-weg'), (q[b.getAttribute('data-weg')] || 0) - 1, false);
      var alle = box.querySelectorAll('[data-weg]'), naechst = alle[Math.min(idx, alle.length - 1)];
      try { (naechst || box.closest('.mbk-zus').querySelector('[data-add]')).focus({ preventScroll: true }); } catch (err) {}
    }
    root.addEventListener('click', slotKlick);
    blatt.addEventListener('click', slotKlick);
    stufen.forEach(function (b) {
      b.addEventListener('click', function () { stufe = { n: +b.getAttribute('data-stufe'), p: +b.getAttribute('data-p') }; hinweis = ''; beschriften(); render(); });
    });

    /* Filter: Nur auf Lager, Farbfamilie, Marke - Zähler = Treffer bei jeder Kombination */
    var schalter = root.querySelector('[data-f-lager]');
    var sels = [].slice.call(root.querySelectorAll('select[data-f]'));
    sels.forEach(function (s) { [].forEach.call(s.options, function (o) { o.setAttribute('data-l', o.textContent); }); });
    var leer = root.querySelector('[data-mbk-leer]');
    function passt(k, f) {
      if (f.lager && k.getAttribute('data-lager') !== '1') return false;
      if (f.fam && k.getAttribute('data-fam') !== f.fam) return false;
      if (f.marke && k.getAttribute('data-marke') !== f.marke) return false;
      return true;
    }
    function zustand() { var f = { lager: !!schalter && schalter.getAttribute('aria-checked') === 'true' }; sels.forEach(function (s) { f[s.getAttribute('data-f')] = s.value; }); return f; }
    function zaehle(f) { return karten.filter(function (k) { return passt(k, f); }).length; }
    function mit(f, k, w) { var o = {}; Object.keys(f).forEach(function (x) { o[x] = f[x]; }); o[k] = w; return o; }
    function filtern() {
      var f = zustand(), sichtbar = 0;
      karten.forEach(function (k) { var ok = passt(k, f); k.hidden = !ok; if (ok) sichtbar++; });
      if (leer) leer.hidden = sichtbar > 0;
      if (schalter) { var t = schalter.querySelector('[data-f-lager-t]'); if (t) t.textContent = (T.nur_lager || '') + ' (' + zaehle(mit(f, 'lager', true)) + ')'; }
      sels.forEach(function (s) { var key = s.getAttribute('data-f'); [].forEach.call(s.options, function (o) { o.textContent = o.getAttribute('data-l') + ' (' + zaehle(mit(f, key, o.value)) + ')'; }); });
      if (S) S.lauf();
    }
    if (schalter) schalter.addEventListener('click', function () { schalter.setAttribute('aria-checked', String(schalter.getAttribute('aria-checked') !== 'true')); filtern(); });
    sels.forEach(function (s) { s.addEventListener('change', filtern); });

    /* Lieferzeit-Hinweis nur, wenn nicht alles auf Lager ist */
    (function () {
      var h = root.querySelector('[data-mbk-lief]'); if (!h) return;
      var z = {}, nicht = 0, vor = 0;
      karten.forEach(function (k) { var r = k.getAttribute('data-rang'), l = (k.getAttribute('data-lief') || '').trim(); if (r === '2') vor++; if (r === '3' && l) { nicht++; z[l] = (z[l] || 0) + 1; } });
      if (!nicht && !vor) return;
      var top = Object.keys(z).sort(function (a, b) { return z[b] - z[a]; })[0] || '';
      var s = [];
      if (nicht) { s.push(tx('lief', { e: gross(E[1]), z: top })); s.push(T.lief_set || ''); }
      if (vor) s.push(T.lief_pre || '');
      h.textContent = s.join(' '); h.hidden = false;
    })();

    /* In den Warenkorb: eine Set-Gruppe, die Bundle-App fasst sie zur Set-Zeile zusammen */
    function hinzufuegen() {
      if (!rechne().ok || laeuft) return;
      var gruppe = 'b' + Math.random().toString(36).slice(2, 9) + Date.now().toString(36);
      var items = reihe.filter(function (v) { return q[v]; }).map(function (v) { return { id: Number(v), quantity: q[v], properties: { _mt_bundle: D.bundle, _mt_group: gruppe } }; });
      laeuft = true;
      addAlle.forEach(function (b) { b.disabled = true; b.textContent = T.busy || ''; });
      H.inDenKorb(D.root, items).then(function () {
        laeuft = false; q = {}; reihe = []; hinweis = '';
        if (L) L.zu();
        render(); H.ansage(live, T.ok || '');
      }).catch(function (err) {
        laeuft = false; hinweis = T.fehler || '';
        render(); H.ansage(live, hinweis);
        H.meldeFehler((err && err.message) ? err.message + ' - ' + hinweis : hinweis);
      });
    }
    addAlle.forEach(function (b) { b.addEventListener('click', hinzufuegen); });

    var L = H.leiste({ leiste: leisteEl, blatt: blatt, hg: root.querySelector('[data-blatt-hg]'), ende: root.querySelector('[data-mbk-ende]'), anzahl: function () { return summe().n; } });
    var S = H.spalte(root, root.querySelector('.mbk-seite'), root.querySelector('[data-mbk-seite]'));
    H.takt(function () { L.lauf(); S.lauf(); });
    beschriften();
    render();
    window.addEventListener('load', function () { beschriften(); render(); });
  }
  function alle() { [].forEach.call(document.querySelectorAll('[data-mfb]'), function (r) { if (!r.__mfb) { r.__mfb = true; start(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
})();
